import teaAvartMale from 'assets/images/teacher_male.png'
import teaAvartFemale from 'assets/images/teacher_female.png'
import stuAvartGirl from 'assets/images/student_girl.png'
import stuAvartBoy from 'assets/images/student_boy.png'
import { commonParams } from 'common/config/config'

export function getHeadImage (headeImage, sex, role) {
  if (headeImage) {
    let converpath = headeImage
    var httpReg = /^(http|https)/
    let oldregx = /(http|https):\/\/leicloud.qiniudn.com\//
    let resregx = /(http|https):\/\/leicloud.ulearning.cn\//
    if (oldregx.test(headeImage)) {
      converpath = headeImage.replace(oldregx, '')
      return commonParams.QINIU_RESOURCE_URL + converpath
    } else if (resregx.test(headeImage)) {
      converpath = headeImage.replace(resregx, '')
      return commonParams.QINIU_RESOURCE_URL + converpath
    } else if (!httpReg.test(headeImage)) {
      return commonParams.QINIU_RESOURCE_URL + headeImage
    } else {
      return headeImage
    }
  }
  if (role !== 9) {
    //  是老师
    if (sex === 1) {
      return teaAvartFemale
    } else {
      return teaAvartMale
    }
  } else {
    if (sex === 1) {
      return stuAvartGirl
    } else {
      return stuAvartBoy
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/getHeadImage.js